import { MeterStatusCode } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const METER_STATUS_CODE_TRANSLATED = defineMessages<MeterStatusCode>({
  [MeterStatusCode.Ok]: { id: 'app.common.meter.status.code.ok' },
  [MeterStatusCode.NotOk]: { id: 'app.common.meter.status.code.notOk' },
  [MeterStatusCode.BatteryLow]: { id: 'app.common.meter.status.code.batteryLow' },
  [MeterStatusCode.BatteryEmpty]: { id: 'app.common.meter.status.code.batteryEmpty' },
  [MeterStatusCode.SignalWeak]: { id: 'app.common.meter.status.code.signalWeak' },
  [MeterStatusCode.WaitingForReadings]: { id: 'app.common.meter.status.code.waitingForReadings' },
  [MeterStatusCode.MissingRemoteReading]: { id: 'app.common.meter.status.code.missingRemoteReading' },
  [MeterStatusCode.MissingManualReading]: { id: 'app.common.meter.status.code.missingManualReading' },
  [MeterStatusCode.ZeroConsumption]: { id: 'app.common.meter.status.code.consumptionZero' },
  [MeterStatusCode.AbsurdConsumption]: { id: 'app.common.meter.status.code.consumptionAbsurd' },
  [MeterStatusCode.NegativeConsumption]: { id: 'app.common.meter.status.code.consumptionNegative' },
});
